/* Eden Hours - refinement layer (behaviour)

   1. Rating display: one decimal place everywhere, without touching the
      stored rating. Rivyo prints the raw average (e.g. 4.55); we rewrite
      only the text node it lands in.
   2. Partial star: keep the gold fill consistent with the rounded number
      now shown beside it.
   3. Sticky add to cart for the flagship pages, which are built in Shogun
      and so never receive the theme's own <sticky-add-to-cart>.
   4. In-stock indicator driven by a server-side availability flag.

   Note on scrolling: this theme scrolls .page-wrapper, not the window, so
   window.scrollY stays at 0. Everything positional below is therefore
   measured from viewport-relative rects, and the scroll listener is bound
   with capture so it hears scroll events from whichever element moves. */
(function () {
  'use strict';

  var CFG = window.EH_REFINE || {};

  function oneDecimal(n) { return (Math.round(n * 10) / 10).toFixed(1); }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function getScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 40) return pw;
    return document.scrollingElement || document.documentElement;
  }

  function scrollState() {
    var s = getScroller();
    var isRoot = s === document.scrollingElement || s === document.documentElement;
    return {
      top: isRoot ? (window.scrollY || s.scrollTop || 0) : s.scrollTop,
      height: isRoot ? window.innerHeight : s.clientHeight,
      total: s.scrollHeight
    };
  }

  /* ---- 1 + 2. rating display ------------------------------------------ */
  function normaliseAverage(el) {
    if (!el || el.dataset.ehRated === '1') return null;
    var value = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType !== 3) continue;
      var raw = node.nodeValue;
      var m = raw.match(/(\d+(?:\.\d+)?)/);
      if (!m) continue;
      value = parseFloat(m[1]);
      if (isNaN(value)) { value = null; continue; }
      node.nodeValue = raw.replace(/\s+/g, ' ').replace(m[1], oneDecimal(value)).trim();
      break;
    }
    var kids = el.querySelectorAll('*');
    for (var k = 0; k < kids.length; k++) {
      if (kids[k].children.length) continue;
      var txt = kids[k].textContent;
      if (txt && /\S/.test(txt)) {
        kids[k].textContent = txt.replace(/\s+/g, ' ')
          .replace(/\(\s+/g, '(').replace(/\s+\)/g, ')').trim();
      }
    }
    el.dataset.ehRated = '1';
    return value;
  }

  function syncPartialStar(widget, rounded) {
    if (rounded === null || rounded === undefined) return;
    var icons = widget.querySelectorAll('.rivyoReviewRatingIcon');
    if (!icons.length) return;
    var whole = Math.floor(rounded);
    var frac = rounded - whole;
    for (var i = 0; i < icons.length; i++) {
      var fill = icons[i].querySelector('.rivyoReviewFill');
      if (!fill) continue;
      if (i === whole && frac > 0.02) fill.style.width = (frac * 100).toFixed(2) + '%';
      else if (i < whole) fill.style.width = '100%';
      else fill.style.width = '0%';
    }
  }

  function refreshRatings() {
    var widgets = document.querySelectorAll('.rivyoReviewWidget');
    for (var i = 0; i < widgets.length; i++) {
      var avg = widgets[i].querySelector('.rivyoReviewAverage');
      if (!avg) continue;
      var value = normaliseAverage(avg);
      if (value !== null) syncPartialStar(widgets[i], Math.round(value * 10) / 10);
    }
    var others = document.querySelectorAll('.wc_review_total_avg, .wc_average_rating, .rivyo_average_rating');
    for (var j = 0; j < others.length; j++) {
      if (others[j].dataset.ehRated === '1') continue;
      var t = others[j].textContent;
      var mm = t && t.match(/^\s*(\d+(?:\.\d+)?)\s*$/);
      if (mm) {
        others[j].textContent = oneDecimal(parseFloat(mm[1]));
        others[j].dataset.ehRated = '1';
      }
    }
  }

  /* ---- 3. sticky add to cart ------------------------------------------ */
  var stickyBar = null;
  var stickyAnchor = null;

  // Find the page's real, clickable add-to-cart control. On Shogun pages the
  // .rca-add-to-cart-submit class sits on BOTH a wrapper <form> and the inner
  // <a> button; clicking the wrapper does nothing, so always resolve to an
  // actual link/button. (Fix 25 Oct 2026.)
  function findNativeButton() {
    var cands = document.querySelectorAll(
      '.rca-add-to-cart-submit, .shg-atc-btn, form[action*="/cart/add"] [type="submit"]'
    );
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el.closest('.eh-sticky')) continue;
      var tag = el.tagName;
      if (tag !== 'A' && tag !== 'BUTTON' && tag !== 'INPUT') {
        el = el.querySelector('a.shg-btn, a, button, [type="submit"]');
        if (!el) continue;
      }
      if (el.disabled) continue;
      if (el.classList.contains('shg-product-atc-disabled')) continue;
      if (el.closest('.shg-product-atc-disabled')) continue;
      return el;
    }
    return null;
  }

  function buildSticky() {
    if (!CFG.product) return;
    if (document.querySelector('sticky-add-to-cart')) return;  // theme has its own
    if (document.querySelector('.eh-sticky')) return;

    var p = CFG.product;
    var bar = document.createElement('div');
    bar.className = 'eh-sticky';
    bar.setAttribute('data-shown', 'false');

    var inner = document.createElement('div');
    inner.className = 'eh-sticky__in';

    if (p.image) {
      var img = document.createElement('img');
      img.className = 'eh-sticky__thumb';
      img.src = p.image;
      img.alt = '';
      img.width = 42;
      img.height = 42;
      img.loading = 'lazy';
      inner.appendChild(img);
    }

    var copy = document.createElement('div');
    copy.className = 'eh-sticky__copy';
    var name = document.createElement('p');
    name.className = 'eh-sticky__name';
    name.textContent = p.title || '';
    copy.appendChild(name);
    if (p.variantTitle) {
      var meta = document.createElement('p');
      meta.className = 'eh-sticky__meta';
      meta.textContent = p.variantTitle;
      copy.appendChild(meta);
    }
    inner.appendChild(copy);

    var price = document.createElement('span');
    price.className = 'eh-sticky__price';
    price.textContent = p.price || '';
    inner.appendChild(price);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eh-sticky__btn';
    if (p.available) { btn.textContent = 'Add to cart'; }
    else { btn.textContent = 'Sold out'; btn.disabled = true; }
    inner.appendChild(btn);

    bar.appendChild(inner);
    document.body.appendChild(bar);
    document.body.classList.add('eh-has-sticky');

    btn.addEventListener('click', function () {
      // Prefer the page's own add-to-cart so Shogun keeps control of
      // quantity, variant and any upsell hooks attached to it.
      var native = findNativeButton();
      if (native) { native.click(); return; }
      if (!p.variantId) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      var id = document.createElement('input');
      id.type = 'hidden'; id.name = 'id'; id.value = p.variantId;
      var qty = document.createElement('input');
      qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1';
      form.appendChild(id); form.appendChild(qty);
      document.body.appendChild(form);
      form.submit();
    });

    stickyBar = bar;
    place();
  }

  function place() {
    if (!stickyBar) return;
    if (!stickyAnchor || !stickyAnchor.isConnected) {
      stickyAnchor = document.querySelector(
        '.rca-add-to-cart-submit, form[action*="/cart/add"], .shg-product-atc'
      );
    }

    var passed;
    if (stickyAnchor) {
      // viewport-relative, so it does not matter which element scrolls
      passed = stickyAnchor.getBoundingClientRect().bottom < 0;
    } else {
      passed = scrollState().top > 520;
    }

    var s = scrollState();
    var nearBottom = s.top + s.height > s.total - 200;

    stickyBar.setAttribute('data-shown', passed && !nearBottom ? 'true' : 'false');
  }

  /* ---- 4. stock status ------------------------------------------------ */
  function buildStock() {
    if (!CFG.product || !CFG.product.available) return;   // real availability
    if (document.querySelector('.eh-stock')) return;
    var host = document.querySelector('.rca-add-to-cart-submit, .shg-product-atc');
    if (!host || !host.parentNode) return;
    var pill = document.createElement('p');
    var qty = CFG.product.quantity;
    if (typeof qty === 'number' && qty > 0 && qty <= 10) {
      pill.className = 'eh-stock eh-stock--low';
      pill.textContent = 'Low stock - ' + qty + ' left';
    } else {
      pill.className = 'eh-stock';
      pill.textContent = 'In stock';
    }
    host.parentNode.insertBefore(pill, host);
  }

  function run() {
    try { refreshRatings(); } catch (e) {}
    try { buildSticky(); } catch (e) {}
    try { buildStock(); } catch (e) {}
    try { place(); } catch (e) {}
  }

  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; try { place(); } catch (e) {} });
  }

  var rerun = debounce(run, 180);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', rerun);

  // capture:true so we hear scroll from .page-wrapper as well as the window
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (window.MutationObserver) {
    new MutationObserver(rerun).observe(document.documentElement, { childList: true, subtree: true });
  }
})();